import React from "react";
import styles from "./FlightCard.module.css";
import { useTranslation } from "../../../../contexts/TranslationContext";

const FlightCard = ({ flights, status, travelers, price }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.flightsContainer}>
        {flights &&
          flights.map((item, index) => (
            <div key={index} className={styles.flight}>
              <div className={styles.flightTitle}>
                <div className={styles.flightTitleLablel}>{item.departure}</div>
                <div className={styles.flightIcon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="8"
                    viewBox="0 0 9 8"
                    fill="none"
                  >
                    <path
                      d="M0.307691 4.01679L7.84819 3.84436M7.84819 3.84436L4.31152 7.54657M7.84819 3.84436L4.14598 0.307686"
                      stroke="#2D343F"
                      stroke-width="0.615385"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className={styles.flightTitleLablel}>{item.destination}</div>
              </div>
              <div className={styles.flightDate}>
                {item.deapartureTime} - {item.arrivedTime} · {item.stops} · {item.airline}
              </div>
            </div>
        ))}
      </div>
      <div className={styles.info}>
        <div className={`${styles.status} ${status === "completed" ? styles.completed : status === "canceled" ? styles.canceled : ""}`}>{status}</div>
        <div className={styles.infoContiainer}>
          <div className={styles.infoLabel}>{travelers}</div>
          <div className={styles.infoLabel}>{t("BasicEco")}</div>
          <div className={styles.price}>
            <div>
              {price}
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M7.5015 0C11.6437 0 15.0023 3.17192 15.0023 7.08475C15.0023 10.9969 11.6437 14.1688 7.5015 14.1688C3.3585 14.1688 0 10.9969 0 7.08475C0 3.17192 3.3585 0 7.5015 0ZM7.5015 1.0625C6.65836 1.05386 5.82177 1.20325 5.04016 1.502C4.25856 1.80076 3.54745 2.24295 2.948 2.80299C2.34854 3.36304 1.87265 4.0298 1.54787 4.7647C1.22308 5.49961 1.05585 6.28805 1.05585 7.0844C1.05585 7.88075 1.22308 8.66919 1.54787 9.40409C1.87265 10.139 2.34854 10.8058 2.948 11.3658C3.54745 11.9258 4.25856 12.368 5.04016 12.6668C5.82177 12.9655 6.65836 13.1149 7.5015 13.1063C9.18058 13.0891 10.7847 12.4471 11.9656 11.3196C13.1465 10.1922 13.8088 8.67028 13.8088 7.0844C13.8088 5.49851 13.1465 3.97663 11.9656 2.84918C10.7847 1.72172 9.18058 1.0797 7.5015 1.0625ZM7.5 6.02154C7.64918 6.02154 7.79226 6.07751 7.89775 6.17714C8.00324 6.27677 8.0625 6.4119 8.0625 6.55279V10.0945C8.0625 10.2354 8.00324 10.3705 7.89775 10.4701C7.79226 10.5697 7.64918 10.6257 7.5 10.6257C7.35082 10.6257 7.20774 10.5697 7.10225 10.4701C6.99676 10.3705 6.9375 10.2354 6.9375 10.0945V6.55279C6.9375 6.4119 6.99676 6.27677 7.10225 6.17714C7.20774 6.07751 7.35082 6.02154 7.5 6.02154ZM7.5 4.95904C7.69891 4.95904 7.88968 4.88441 8.03033 4.75158C8.17098 4.61874 8.25 4.43857 8.25 4.25071C8.25 4.06285 8.17098 3.88268 8.03033 3.74984C7.88968 3.617 7.69891 3.54238 7.5 3.54238C7.30109 3.54238 7.11032 3.617 6.96967 3.74984C6.82902 3.88268 6.75 4.06285 6.75 4.25071C6.75 4.43857 6.82902 4.61874 6.96967 4.75158C7.11032 4.88441 7.30109 4.95904 7.5 4.95904Z" fill="#12234F"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlightCard;
 